import { render, staticRenderFns } from "./ElectronicFilingStatementAPS.vue?vue&type=template&id=3e7c10f0"
import script from "./ElectronicFilingStatementAPS.vue?vue&type=script&lang=ts"
export * from "./ElectronicFilingStatementAPS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports